import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useComponenteDropdownList(filters: any) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_COMPONENTE, filters],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_DROPDOWN_COMPONENTE, {
        params: filters,
      });
      
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters,
    }
  );
}

export default useComponenteDropdownList;